import {invokeTauriCommand, isTauriAvailable} from "../utils/tauri";

/**** Durable upload queue pass-throughs (replaces the prior
 * startDataAcquisition / stopDataAcquisition / listDataAcquisitions
 * surface). All commands gate on isTauriAvailable() and forward to
 * invokeTauriCommand.
 *
 * Wire format: every payload is nested under `{ args: { ...snake_case } }`.
 * Tauri's top-level camelCase auto-rename applies to flat command
 * args (none here) but NOT to nested struct fields — so the inner
 * snake_case is what reaches Rust unchanged. To add a new field:
 * bump the Rust `*Args` struct, then add a snake_case key here. */

export const startDataCollection = async (config: {
    companyId: string
    protocolId: string
    sources: Array<{
        dirPath: string
        recursive: boolean
        extensions: string[]
        minFileAgeSeconds: number
        backupSourceOnCopy: boolean
    }>
    protocolStepId?: string
}): Promise<void> => {
    if (!isTauriAvailable()) throw new Error('Tauri unavailable')
    await invokeTauriCommand('start_data_collection', {
        args: {
            company_id: config.companyId,
            protocol_id: config.protocolId,
            sources: config.sources.map((s) => ({
                dir_path: s.dirPath,
                recursive: s.recursive,
                extensions: s.extensions,
                min_file_age_seconds: s.minFileAgeSeconds,
                backup_source_on_copy: s.backupSourceOnCopy,
            })),
            protocol_step_id: config.protocolStepId ?? null,
        },
    })
}

export const stopDataCollection = async (): Promise<void> => {
    if (!isTauriAvailable()) throw new Error('Tauri unavailable')
    await invokeTauriCommand('stop_data_collection', {args: {}})
}